import { useNavigate, useSearchParams } from 'react-router-dom'
import StatisticsForm from './StatisticsForm'
import StatisticsSummary from './StatisticsSummary'
import StatisticsDetail from './StatisticsDetail'
import './Statistics.css'

export default function Statistics() {
  const [searchParams] = useSearchParams()
  console.log('Statistics rendered: ', searchParams)
  const navigate = useNavigate()

  const eventId = searchParams.get('eventId') ? parseInt(searchParams.get('eventId')) : ''
  const userId = searchParams.get('userId') ? parseInt(searchParams.get('userId')) : ''
  const fromDate = searchParams.get('fromDate') ? searchParams.get('fromDate') : ''
  const toDate = searchParams.get('toDate') ? searchParams.get('toDate') : ''
  const start = searchParams.get('start') ? parseInt(searchParams.get('start')) : 1
  const parameters = {
    eventId: eventId,
    userId: userId,
    fromDate: fromDate,
    toDate: toDate,
    start: start
  }

  function setRoute(inputs) {
    console.log('Statistics.setRoute', inputs)
    let params = ''
    if (inputs.eventId || inputs.userId || inputs.fromDate || inputs.toDate) {
      let delimiter = '?'
      for (let inputName in inputs) {
        if (inputs[inputName] && inputName !== 'start') {
          params += `${delimiter}${inputName}=${inputs[inputName]}`
          delimiter = '&'
        }
      }
    }
    navigate(`/statistics${params}`)
  }

  let gridComponent = <StatisticsSummary parameters={ parameters }/>
  if (eventId || userId) {
    gridComponent = <StatisticsDetail parameters={ parameters } />
  }

  return (
    <div className="statistics-page">
      <div className="statistics-container">
        <StatisticsForm parameters={ parameters } setRoute={setRoute} />
        {gridComponent}
      </div>
    </div>
  )
}
